
let AllChars = [];

for (let i=97; i<123; i++) {
  AllChars.push(String.fromCharCode(i));
}

// Add AA, AB, AC etc... if we need them.
for (let i=97; i<123; i++) {
  for (let j=97; j<123; j++) {
    AllChars.push(String.fromCharCode(i) + String.fromCharCode(j));
  }
}

let usedConditions = [];
function popConditionId() {
  const c = AllChars.find(c => !usedConditions.includes(c));
  usedConditions = usedConditions.concat(c);
  return `condition-${c}`;
}
function resetConditionId(conditionId) {
  usedConditions = usedConditions.filter(c => c !== conditionId);
}

let usedLogics = [];
function popLogicId() {
  const c = AllChars.find(c => !usedLogics.includes(c));
  usedLogics = usedLogics.concat(c);
  return `logic-${c}`;
}
function resetLogicId(logicId) {
  usedLogics = usedLogics.filter(c => c !== logicId);
}

function resetIds() {
  usedConditions = [];
  usedLogics = [];
}

const operators = {and: 'and', or: 'or', not: 'not', condition: 'condition'}
const hasChildren = (operator) => (operator === operators.and || operator === operators.or)
const isLogical = (operator) => (hasChildren(operator) || operator === operators.not)

export default Object.freeze({
  hasChildren, isLogical, popConditionId, resetConditionId, popLogicId, resetLogicId, resetIds,
  ...operators
});